<template>
	<div :class="myimg">
		<div class="inner-img">
				<top-image :myimg="myimg"></top-image>
		</div>
		<div class="charper1">
			<!-- <large-search class="search-box"></large-search> -->
			<span class="main-text">{{mainText}}</span>
		</div>
		<router-view></router-view>
	</div>
</template>

<script type="text/ecmascript-6">
	import TopImage from 'components/top-image/top-image'
	import largeSearch from 'common/large-search/large-search'

	export default {
		data() {
			return {
				myimg: 'poruduct-center'
			}
		},
		computed: {
			mainText() {
				return this.$t('mainText')
			}
		},
		components:{
			TopImage,
			largeSearch
		}
	}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"
	.charper1
		position: relative
		display: flex
		margin-bottom: 100px
		@media screen and (max-width:550px)
			margin-bottom: 50px
		.search-box
			width: 28%
			flex: 0 0 28%
			margin: -30px 0 0 100px
			@media screen and (max-width:550px)
				display: none
		.main-text
			padding: 0 100px
			margin-top: 30px
			font-size: $font-web-small
			line-height: $font-web-medium
			@media screen and (max-width:550px)
				font-size: $font-web-small
			@media screen and (max-width:750px)
				padding: 0 50px
				font-size: $font-web-small
</style>



// WEBPACK FOOTER //
// src/components/prouduct-center/prouduct-center.vue